import { RootState } from "../reducers";

export const getMouseLabel = ({ mouseLabel }: RootState): string => mouseLabel && mouseLabel.text;
